import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PreSimulationService } from "./service/pre-simulation.service";
import { CustomerService } from "src/app/services/customer/customer.service";
import { CountryService } from "src/app/services/country/country.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-pre-simulation",
  templateUrl: "./pre-simulation.component.html",
  styleUrls: ["./pre-simulation.component.scss"],
})
export class PreSimulationComponent implements OnInit, OnDestroy {
  preSimulationForm: UntypedFormGroup;
  customers: { id: number; description: string }[] = [];
  countries: { id: number; description: string; code: string }[] = [];

  constructor(
    private preSimulationService: PreSimulationService,
    private customerService: CustomerService,
    private countryService: CountryService
  ) {}

  ngOnInit() {
    this.preSimulationForm = new UntypedFormGroup({
      customer: new UntypedFormControl(null, Validators.required),
      country: new UntypedFormControl(null, Validators.required),
      test: new UntypedFormControl(false),
    });

    this.preSimulationForm.valueChanges.subscribe(() => {
      this.preSimulationService.updateFormValidity(
        this.preSimulationForm.valid,
        this.preSimulationForm
      );
      this.preSimulationService.updateForm(this.preSimulationForm);
    });

    this.preSimulationForm.get('test').valueChanges.subscribe((isTest: boolean) => {
      const customerCtrl = this.preSimulationForm.get('customer');
      const countryCtrl = this.preSimulationForm.get('country');
      if (isTest) {
        customerCtrl.clearValidators();
        countryCtrl.clearValidators();
        customerCtrl.setValue(null);
        countryCtrl.setValue(null);
        customerCtrl.disable();
        countryCtrl.disable();
      } else {
        customerCtrl.setValidators(Validators.required);
        countryCtrl.setValidators(Validators.required);
        customerCtrl.enable();
        countryCtrl.enable();
      }
      customerCtrl.updateValueAndValidity();
      countryCtrl.updateValueAndValidity();
    });

    this.preSimulationService.customerCreated$.subscribe((customer) => {
      if (customer) {
        this.customerService.getPreSimulationActiveCustomers().subscribe((customers) => {
          this.customers = customers;
          this.preSimulationForm.get("customer").setValue(customer);
        });
      }
    });

    this.preSimulationService.customerIdChanges$.subscribe((id) => {
      this.preSimulationForm.get("customer").setValue(this.customers.find(customer => customer.id === id));
    });

    this.preSimulationService.countryIdChanges$.subscribe((id) => {
      this.preSimulationForm.get("country").setValue(this.countries.find(country => country.id === id));
    });

    this.getPreSimulationData();
  }

  countrySearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return (
      item.description.toLowerCase().indexOf(term) > -1 ||
      item.code.toLowerCase().indexOf(term) > -1
    );
  }

  ngOnDestroy(): void {}

  addCustomer() {
    this.preSimulationService.setCustomers(this.customers);
  }

  private getPreSimulationData() {
    forkJoin({
      customers: this.customerService.getPreSimulationActiveCustomers(),
      countries: this.countryService.getActiveCountries(),
    }).subscribe(({ customers, countries }) => {
      this.customers = customers;
      this.countries = countries;
      this.preSimulationService.setCountries(countries);
    });
  }

  public validateBeforeAction(): boolean {
    const isTest = this.preSimulationForm.get('test').value;
    if (!isTest) {
      this.preSimulationForm.get('customer').setValidators(Validators.required);
      this.preSimulationForm.get('country').setValidators(Validators.required);
      this.preSimulationForm.get('customer').updateValueAndValidity();
      this.preSimulationForm.get('country').updateValueAndValidity();
      if (!this.preSimulationForm.get('customer').value || !this.preSimulationForm.get('country').value) {
        return false;
      }
    }
    return true;
  }
}
